import type { JsonObject } from '@seen/core/json'
import type { GroupedMedication } from '@seen/core/models/currentMedications'

export function buildMedicationListBlock(
  heading: string,
  medications: GroupedMedication[]
): JsonObject[] {
  const mentions = medications.flatMap((medication) => {
    const id = medication.id
    const display = medication.medicationDisplay
    return id && display ? [{ id, display }] : []
  })

  if (mentions.length === 0) {
    return []
  }

  return [
    {
      type: 'paragraph',
      content: [
        {
          type: 'text',
          marks: [{ type: 'bold' }],
          text: heading,
        },
      ],
    },
    {
      type: 'bulletList',
      content: mentions.map((m) => ({
        type: 'listItem',
        content: [
          {
            type: 'paragraph',
            content: [
              {
                type: 'mention',
                attrs: {
                  reference: `MedicationRequest/${m.id}`,
                  display: m.display,
                },
              },
            ],
          },
        ],
      })),
    },
  ]
}
